import React from "react";

const CSS = `
@keyframes atlas-pulse { 0%,100%{opacity:.4} 50%{opacity:.9} }
.atlas-skel{ border-radius:var(--radius-md); background:var(--surface-raised); animation:atlas-pulse 1.6s ease-in-out infinite; }
`;

function ensure() {
  if (typeof document === "undefined") return;
  if (!document.getElementById("atlas-skel-css")) {
    const s = document.createElement("style");
    s.id = "atlas-skel-css";
    s.textContent = CSS;
    document.head.appendChild(s);
  }
}

interface SkelProps {
  width?: string | number;
  height?: string | number;
  radius?: string;
}

export function Skel({ width = "100%", height = "20px", radius }: SkelProps) {
  ensure();
  return (
    <div
      className="atlas-skel"
      style={{ width, height, ...(radius ? { borderRadius: radius } : {}) }}
    />
  );
}
